import * as React from "react";
import Badge from "material-ui/Badge";
import { format } from "lib/globalize-util";

const styles = {
    base: {
        padding: 0,
    },
    badge: {
        top: "8px",
        right: "auto",
        left: "105%",
        borderRadius: "15%",
        padding: "0px 3px",
        height: "18px",
        fontSize: "11px",
        width: "auto",
        backgroundColor: "#2fc7be",
        color: "white",
    },
    indicator: {
        top: "-18px",
        right: "-36px",
        borderRadius: "100%",
        width: "7px",
        height: "7px",
        backgroundColor: "#2fc7be",
    },
};

export const NewBadge = ({ label, badge }: { label: string; badge?: string | number }) => {
    return (
        <Badge badgeContent={badge || format("New!")} badgeStyle={styles.badge} style={styles.base}>
            {label}
        </Badge>
    );
};

export const NewIndicator = () => {
    return <Badge badgeContent={""} badgeStyle={styles.indicator} style={styles.base} />;
};
